import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://bancariosrs.com.br/api/public/api/',
});

export default instance;